import { useEffect, useState } from "react";
import { WifiOff } from "lucide-react";

export default function OfflineBanner() {
  const [offline, setOffline] = useState(typeof navigator !== "undefined" && navigator.onLine === false);
  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);
  if (!offline) return null;
  return (
    <div className="shrink-0 z-40 bg-destructive text-destructive-foreground text-sm" data-testid="offline-banner">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center justify-center gap-2">
        <WifiOff size={15} /> You're offline — changes may not save until you reconnect.
      </div>
    </div>
  );
}
